//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    hasMobileImg: Boolean,
    hasTabletImg: Boolean,
    img: String,
    txt1: String,
    txt2: String,
    txt3: String,
    height: String,
    txt1Color: String,
    txt2Color: String,
    marginTop: String,
    marginLeft: String,
    fontSize: String,
    useslot: Boolean,
    useslot1: Boolean,
  },
  data() {
    return {
      estasubindo: false,
      oldScroll: 2,
    }
  },
  computed: {
    computedStyle() {
      if (this.$imagine) {
        let i
        if (this.hasMobileImg && this.$sc.isCell) {
          i = this.img.split('.')[0] + '-mobile' + '.' + this.img.split('.')[1]
        } else if (this.hasTabletImg && this.$sc.largeTabletAndDown) {
          i = this.img.split('.')[0] + '-tablet' + '.' + this.img.split('.')[1]
        } else {
          i = this.img ? this.img : '/quem-somos.jpg'
        }

        let img = `background: url(${this.$imagine(i)}) center / cover`

        let h = this.height ? this.height : 'calc(50vh + 50px)'
        let height = `height: ${h}`

        let top = `top: 0`

        let style = `${img}; ${top}; ${height}`

        return style
      }
    },
  },
  // mounted() {
  //   addEventListener('scroll', () => {
  //     let estasubindo = this.oldScroll > scrollY
  //     this.estasubindo = estasubindo
  //     this.oldScroll = scrollY

  //     let text1 = document.querySelector('.txt1')
  //     let text2 = document.querySelector('.txt2')

  //     if (text1 && text2) {
  //       let classList1 = text1.classList
  //       let classList2 = text2.classList

  //       if (this.estasubindo) {
  //         Array.from(classList1).includes('estadescendo')
  //           ? classList1.remove('estadescendo')
  //           : ''
  //         Array.from(classList2).includes('estadescendo')
  //           ? classList2.remove('estadescendo')
  //           : ''
  //         classList1.add('estasubindo')
  //         classList2.add('estasubindo')
  //       } else {
  //         Array.from(classList1).includes('estasubindo')
  //           ? classList1.remove('estasubindo')
  //           : ''
  //         Array.from(classList2).includes('estasubindo')
  //           ? classList2.remove('estasubindo')
  //           : ''
  //         classList1.add('estadescendo')
  //         classList2.add('estadescendo')
  //       }
  //     }

  //     let slot = document.querySelector('.slot')
  //     let slot1 = document.querySelector('.slot1')

  //     if (this.useslot || this.useslot1) {
  //       let classListSlot
  //       if (this.useslot) {
  //         classListSlot = slot.classList
  //       } else {
  //         classListSlot = slot1.classList
  //       }

  //       if (this.estasubindo) {
  //         Array.from(classListSlot).includes('estadescendo')
  //           ? classListSlot.remove('estadescendo')
  //           : ''

  //         classListSlot.add('estasubindo')
  //       } else {
  //         Array.from(classListSlot).includes('estasubindo')
  //           ? classListSlot.remove('estasubindo')
  //           : ''

  //         classListSlot.add('estadescendo')
  //       }
  //     }
  //     let txt3 = document.querySelector('.txt3')

  //     if (txt3) {
  //       let classListtxt3 = txt3.classList

  //       if (this.estasubindo) {
  //         Array.from(classListtxt3).includes('estadescendo')
  //           ? classListtxt3.remove('estadescendo')
  //           : ''

  //         classListtxt3.add('estasubindo')
  //       } else {
  //         Array.from(classListtxt3).includes('estasubindo')
  //           ? classListtxt3.remove('estasubindo')
  //           : ''

  //         classListtxt3.add('estadescendo')
  //       }
  //     }
  //   })
  // },
}
